import i18next from 'i18next';
import client from './client';

export namespace OneTimePasscodeService {
  export enum CustomStatusCode {
    InvalidDetails = 4001,
    AccountLocked = 4023,
    Expired = 4103,
    ServiceDown = 4503
  }

  export interface GeneratePayload {
    accountNumber: string;
    postcode: string;
    surname: string;
    dob: string;
  }

  export interface GenerateResponse {
    customStatusCode: CustomStatusCode;
    resendDisable: boolean;
    otpResendCount: number;
  }

  export type ResendPayload = GeneratePayload;
  export type ResendResponse = GenerateResponse;

  export interface ValidatePayload {
    authenticationRequest: GeneratePayload;
    otpCode: string;
  }

  export interface ValidateResponse {
    customStatusCode: CustomStatusCode;
    token: string;
  }

  export const generate = async (payload: GeneratePayload) => {
    const { data } = await client<GenerateResponse>({
      method: 'POST',
      url: `${process.env.REACT_APP_4QV_API_PATH}/generate-otp`,
      data: payload,
      headers: {
        'X-Journey': 'cst',
        'X-Channel': 'organic'
      }
    });

    return data;
  };

  export const resend = async (payload: ResendPayload) => {
    try {
      const { data } = await client<ResendResponse>({
        method: 'POST',
        url: `${process.env.REACT_APP_4QV_API_PATH}/resend-otp`,
        data: payload,
        headers: {
          'X-Journey': 'cst'
        }
      });

      return data;
    } catch (err) {
      throw new Error(i18next.t('generic.serverError'));
    }
  };

  export const validate = async (payload: ValidatePayload) => {
    const { data } = await client<ValidateResponse>({
      method: 'POST',
      url: `${process.env.REACT_APP_4QV_API_PATH}/validate-otp`,
      data: payload,
      headers: {
        'X-Journey': 'cst',
        'X-Channel': 'organic'
      }
    });

    if (data.customStatusCode === CustomStatusCode.Expired) {
      throw new Error(i18next.t('oneTimePasscode.error.expired'));
    }

    if (data.customStatusCode === CustomStatusCode.InvalidDetails) {
      throw new Error(i18next.t('oneTimePasscode.error.incorrect'));
    }

    return data;
  };
}
